export const USER = {
  // Your personal information
  firstName: "Sarthak",
  lastName: "Shitole",
  displayName: "Sarthak",
  username: "sarthak", // A more professional username for URLs
  gender: "male",
  pronouns: "he/him",

  // Your professional details
  jobTitle: "Full Stack Developer | UI/UX Designer",
  jobs: [
    {
      title: "Open to Opportunities:",
      company: "Full-time | Contract | Freelance",
      website: "", // No website needed for plain text
    },
  ],

  // The sentences that flip on the homepage
  bio: "22, Creating. Mostly for myself.",
  flipSentences: [
    "Full Stack Developer",
    "UI/UX Designer",
    "AI & ML Enthusiast",
    "Open Source Contributor",
    "Community Builder",
  ],

  // Contact and location
  address: "India",
  phoneNumber: "", // Keep empty or provide a Base64 encoded E.164 number if you wish
  email: "d29ya3Muc2FydGhha3NAZ21haWwuY29t", // Your email "works.sarthaks@gmail.com" is Base64 encoded
  website: "https://sarthaks.tech",
  device: "MacBook Air M4",

  // About Me section
  about: `
Hello World!, I'm Sarthak! A CS Grad passionate about creating high-performance, user-centric software solutions with intuitive and engaging designs. I am building impactful solutions and contributing to the developer community. 

I specialize in building high-quality web and mobile applications using Next.js, React, TypeScript, and modern front-end technologies. I also am heavily leaned towards the worlf of AI and its Applications and built some passion projects around it.

Beyond work, I love exploring new technologies and turning ideas into reality through personal projects (A Lot).

When I'm not coding, you'll find me diving into classic literature, crafting pixel-perfect designs in Figma, or analyzing tech references in movies and shows. I'm always open to collaborating on open-source projects and exploring new opportunities. 

Let's connect and collaborate in build something amazing together!
  `,

  // Assets and SEO
  avatar: "/sarthak-avatar.png", // Suggested path: create a 'public' folder in your root and place 'sarthak-avatar.jpg' inside
  ogImage: "/sarthak-og-image.png", // Suggested path: place in the 'public' folder
  keywords:
    "Sarthak Shitole, Sarthak, Sarthak, 22, Creating. Mostly for myself | Prev dev @ startup x1, Working 15 hrs a day till I retire my parents,",
  dateCreated: "2025-08-16", // The date you are setting this up
};
